import { gql } from 'apollo-angular';

export type UpdateDispositionDetailInput = {
  disposition_gp_transfer_status_id: number | null;
  disposition_refinancing_status_id: number | null;
  forced_sale_right: boolean | null;
  disposition_notes: string | null;
};

const DISPOSITION_DETAILS_FRAGMENT = gql`
  fragment DispositionDetailsFields on DispositionDetail {
    id
    project_id
    disposition_gp_transfer_status_id
    disposition_refinancing_status_id
    forced_sale_right
    disposition_notes
    permission {
      _create
      _edit
      _read
      _delete
    }
  }
`;
const GET_DISPOSITION_DETAILS = gql`
  query getDispositionDetails($project_id: ID!) {
    getDispositionDetail(project_id: $project_id) {
      ...DispositionDetailsFields
    }
    getDispositionGpTransferStatuses {
      id
      name
      index
    }
    getDispositionRefinancingStatuses {
      id
      name
      index
    }
    getProjectDetail(project_id: $project_id) {
      id
      fully_disposed
      permission {
        _create
        _edit
        _read
        _delete
      }
    }
    me {
      permissionsForResource(resourceType: DISPOSITIONDETAIL) {
        _create
        _read
        _edit
        _delete
      }
    }
  }
  ${DISPOSITION_DETAILS_FRAGMENT}
`;
const CREATE_DISPOSITION_DETAILS = gql`
  mutation createDispositionDetail($project_id: ID!) {
    createDispositionDetail(project_id: $project_id) {
      ...DispositionDetailsFields
    }
  }
  ${DISPOSITION_DETAILS_FRAGMENT}
`;

const UPDATE_DISPOSITION_DETAILS = gql`
  mutation updateDispositionDetail(
    $disposition_detail_id: ID!
    $disposition_detail_input: UpdateDispositionDetailInput
    $project_detail_id: ID!
    $project_detail_input: ProjectDetailFullyDisposedInput
  ) {
    updateDispositionDetail(
      id: $disposition_detail_id
      input: $disposition_detail_input
    ) {
      ...DispositionDetailsFields
    }
    updateProjectDetail(id: $project_detail_id, input: $project_detail_input) {
      id
      fully_disposed

      permission {
        _create
        _edit
        _read
        _delete
      }
    }
  }
  ${DISPOSITION_DETAILS_FRAGMENT}
`;

export {
  GET_DISPOSITION_DETAILS,
  CREATE_DISPOSITION_DETAILS,
  UPDATE_DISPOSITION_DETAILS,
};
